import React from "react";
import { PulseLoader } from "react-spinners";

function CommonButton({
  text = "Button",
  onClick,
  className = "",
  isLoading = false,
  loaderColor = "#fff",
  style = {},
  type = "button",
  disabled = false,
  ...props
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={isLoading || disabled}
      className={className}
      {...props}
      style={{
        color: "#315D99",
        border: "1px solid #325D99",
        background: "none",
        padding: "9px 20px",
        minWidth: "84px",
        borderRadius: "2px",
        cursor: isLoading ? "not-allowed" : "pointer",
        opacity: isLoading ? 0.7 : 1,
        ...style,
      }}

    >
      {isLoading ? (
        <PulseLoader
          color={loaderColor}
          size={8}
          aria-label="Loading Spinner"
        />
      ) : (
        text
      )}
    </button>
  );
}

export default CommonButton;
